import { render, staticRenderFns } from "./introDetail.vue?vue&type=template&id=b51b7c3a&scoped=true&"
import script from "./introDetail.vue?vue&type=script&lang=js&"
export * from "./introDetail.vue?vue&type=script&lang=js&"
import style0 from "./introDetail.vue?vue&type=style&index=0&id=b51b7c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51b7c3a",
  null
  
)

export default component.exports